// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24T5g","rootMobile":"styles_rootMobile__2E3-3"};